import React, { useCallback, useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import styles from "./navBanner.scss";

const NavBanner = (props) => {
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState(0);
  const { pageRef, galleryRef, infoRef, triggerRef, recoProductsRef } = props;

  const getTop = (i) => {
    if (i === 0) return 0;
    if (i === 1)
      return infoRef?.current?.offsetTop - pageRef?.current?.offsetTop;
    return 0;
  };

  const handleChange = (e, i) => {
    if (!pageRef.current || !galleryRef.current || !infoRef.current || !recoProductsRef.current) return;

    if (i === 2) {
      window.scrollTo(
        0,
        recoProductsRef?.current?.offsetTop - 2 * pageRef?.current?.offsetTop
      );
    } else {
        window.scrollTo({
          top: getTop(i),
          behavior: "smooth",
        });
      }

    setActive(i);
  };

  const ifScrolled = (sectionRef) => {
    if (!sectionRef) return false;
    return (
      window.scrollY >
      sectionRef.offsetTop + sectionRef.offsetHeight - window.innerHeight / 4
    );
  };

  const scrollHandler = useCallback(() => {
    if (visible !== ifScrolled(triggerRef.current)) {
      setVisible(ifScrolled(triggerRef.current));
    }
    if (ifScrolled(infoRef.current)) {
      return setActive(2);
    }
    if (ifScrolled(galleryRef.current)) {
      return setActive(1);
    }

    return setActive(0);
  }, [visible]);

  useEffect(() => {
    if (!pageRef.current || !galleryRef.current || !infoRef.current || !recoProductsRef.current) return;

    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, [scrollHandler]);

  const navs = [
    {
      title: "產品圖片",
    },
    {
      title: "產品說明",
    },
    {
      title: "產品推薦",
      //disabled: true,
    },
  ];

  if (!visible) return null;

  return (
    <div
      className={styles["wrapper"]}
      style={{ top: pageRef && pageRef.current.offsetTop }}
    >
      <Tabs
        className={styles["tabs-root"]}
        classes={{
          flexContainer: styles["tabs-container"],
        }}
        value={active}
        onChange={handleChange}
        TabIndicatorProps={{ className: styles["tab-indicator"] }}
      >
        {navs.map((nav, i) => (
          <Tab
            label={<span className={styles["tab-label"]}>{nav?.title}</span>}
            classes={{
              root: styles["tab-root"],
              wrapper: styles["tab-label"],
              selected: styles["tab-label-selected"],
            }}
            id={`nav-tab-${i}`}
            key={i}
            disabled={nav.disabled}
          />
        ))}
      </Tabs>
    </div>
  );
};

export default NavBanner;
